export function updateValue(state, action) {
  const data = state.data || [];
  const dataCached = state.dataCached || [];

  if (!data.length) {
    return {
      data,
      dataCached,
      dataCachedUpdatedAt: state.dataCachedUpdatedAt,
    };
  }

  if (!action.data.length) {
    return {
      data,
      dataCached,
      dataCachedUpdatedAt: state.dataCachedUpdatedAt,
    };
  }

  const newData = [...data];
  const newDataCached = [...dataCached];

  const targetItems = action.data;

  let isUpdated = false;

  for (let i = 0; i < targetItems.length; i++) {
    const targetItem = targetItems[i];
    const targetId = targetItem.id;
    const targetProp = targetItem.name;
    const targetValue = targetItem.value;

    const targetDataIndex = newData.findIndex((item) => item._id === targetId);
    const targetDataCachedIndex = newDataCached.findIndex(
      (item) => item._id === targetId
    );

    if (targetDataIndex >= 0) {
      newData[targetDataIndex][targetProp] = targetValue;
      isUpdated = true;
    }

    if (targetDataCachedIndex >= 0) {
      newData[targetDataCachedIndex][targetProp] = targetValue;
      isUpdated = true;
    }
  }

  return {
    data,
    dataCached,
    dataCachedUpdatedAt: isUpdated ? Date.now() : state.dataCachedUpdatedAt,
  };
}

export function updateValueBulk(state, action) {
  const data = state.data || [];
  const dataCached = state.dataCached || [];

  if (!data.length) {
    return {
      data,
      dataCached,
      dataCachedUpdatedAt: state.dataCachedUpdatedAt,
    };
  }

  if (!action.data.name || !action.data.data.length) {
    return {
      data,
      dataCached,
      dataCachedUpdatedAt: state.dataCachedUpdatedAt,
    };
  }

  const newData = [...data];
  const newDataCached = [...dataCached];

  const targetItems = action.data.data;
  const targetProp = action.data.name;
  const targetValue = action.data.value;

  let isUpdated = false;

  for (let i = 0; i < targetItems.length; i++) {
    const targetItem = targetItems[i];

    const targetDataIndex = newData.findIndex(
      (item) => item._id === targetItem
    );
    const targetDataCachedIndex = newDataCached.findIndex(
      (item) => item._id === targetItem
    );

    if (targetDataIndex >= 0) {
      newData[targetDataIndex][targetProp] = targetValue;
      isUpdated = true;
    }

    if (targetDataCachedIndex >= 0) {
      newData[targetDataCachedIndex][targetProp] = targetValue;
      isUpdated = true;
    }
  }

  return {
    data,
    dataCached,
    dataCachedUpdatedAt: isUpdated ? Date.now() : state.dataCachedUpdatedAt,
  };
}

export function updateSelectAll(state, action) {
  const data = state.data || [];
  const dataCached = state.dataCached || [];
  const value = action.data.value;

  if (!data.length) {
    return {
      data,
      dataCached,
      dataCachedUpdatedAt: state.dataCachedUpdatedAt,
    };
  }

  let isUpdated = true;

  const newData = [];
  const newDataCached = [];

  for (let i = 0; i < data.length; i++) {
    const targetData = data[i];

    if (targetData?.retryInProgress) {
      continue;
    }

    targetData.selected = value;

    newData.push(targetData);
  }

  for (let i = 0; i < dataCached.length; i++) {
    const targetDataCached = dataCached[i];

    if (targetDataCached?.retryInProgress) {
      continue;
    }

    targetDataCached.selected = value;

    newDataCached.push(targetDataCached);
  }

  if (!isUpdated) {
    return {
      data,
      dataCached,
      dataCachedUpdatedAt: state.dataCachedUpdatedAt,
    };
  }

  return {
    data: newData,
    dataCached: newDataCached,
    dataCachedUpdatedAt: Date.now(),
  };
}

export function updateRetryAttemptCounts(state, action) {
  const retryAttempts = [...state.retryAttempts];
  const newData = action.data;

  for (let i = 0; i < newData.length; i++) {
    const newDataItem = newData[i];
    const targetIndex = retryAttempts.findIndex(
      (t) =>
        t.positionId === newDataItem.positionId &&
        t.algoId == newDataItem.algoId
    );

    if (targetIndex >= 0) {
      retryAttempts[targetIndex].error = newDataItem.error;
      retryAttempts[targetIndex].count = retryAttempts[targetIndex].count + 1;
    } else {
      retryAttempts.push({
        ...newDataItem,
        count: 1,
      });
    }
  }

  return retryAttempts;
}

export function clearRetryAttemptCounts(state, action) {
  const retryAttempts = [...state.retryAttempts];
  const newData = action.data;

  for (let i = 0; i < newData.length; i++) {
    const newDataItem = newData[i];
    const targetIndex = state.retryAttempts.findIndex(
      (t) =>
        t.positionId === newDataItem.positionId &&
        t.algoId == newDataItem.algoId
    );

    if (targetIndex < 0) {
      continue;
    }

    retryAttempts[targetIndex] = null;
  }

  return retryAttempts.filter((item) => item);
}
